import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function Navbar() {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const handleMobileMenuToggle = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const handleDropdownToggle = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  return (
    <div>
      <header id="header" className="fixed-top d-flex align-items-center">
        <div className="container d-flex align-items-center">
          <Link to="/" className="logo me-auto">
            <img src="assets/img/logo.png" alt="" />
          </Link>
          <nav
            id="navbar"
            className={`order-last order-lg-0 navbar${
              isMobileMenuOpen ? '-mobile' : ''
            }`}
          >
            <ul>
              <li>
                <Link
                  to="/"
                  className="nav-link scrollto"
                  onClick={closeMobileMenu}
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/About"
                  className="nav-link scrollto"
                  onClick={closeMobileMenu}
                >
                  About
                </Link>
              </li>
              <li className="dropdown">
                <Link
                  to="#"
                  className="nav-link scrollto"
                  onClick={handleDropdownToggle}
                >
                  Services <i className="bi bi-chevron-down" />
                </Link>
                <ul className={`dropdown ${isDropdownOpen ? 'dropdown-active' : ''}`}>
                  <li>
                    <Link to="/BuildDocmentation"  onClick={closeMobileMenu}>As-Built Documentation</Link>
                  </li>
                  <li>
                    <Link to="/PointCloudModeling"  onClick={closeMobileMenu}>Point Cloud Modeling</Link>
                  </li>
                  <li>
                    <Link to="#IndustrialScanningServices"  onClick={closeMobileMenu}>Industrial Scanning Services</Link>
                  </li>
                  <li>
                    <Link to="/ConstructionScanningServices"  onClick={closeMobileMenu}>Construction Scanning Services</Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link
                  to="#portfolio"
                  className="nav-link scrollto"
                  onClick={closeMobileMenu}
                >
                  Projects
                </Link>
              </li>
              <li>
                <Link
                  to="/Contact"
                  className="nav-link scrollto"
                  onClick={closeMobileMenu}
                >
                  Contact
                </Link>
              </li>
            </ul>
            <i
              className={`bi ${isMobileMenuOpen ? 'bi-x' : 'bi-list'} mobile-nav-toggle`}
              onClick={handleMobileMenuToggle}
            />
          </nav>
        </div>
      </header>
    </div>
  );
}

export default Navbar;
